import PropTypes from 'prop-types';
import React from 'react';

import StyledInfoGraphic from './infoGraphic.style';
import FuturiumIcon from '../../icons/futurium-iconset/futurium-iconset';
import Headline from '../../atoms/headline/headline';

import MixedCopy from '../mixed-copy/mixedCopy';

const InfoGraphic = ({ vertical = false, alignment, icon, number, subline, copy, ...props }) => {
  return (
    <StyledInfoGraphic
      alignment={alignment}
      vertical={vertical}
      hasIcon={icon}
      numberLength={number ? number.length : 0}
      {...props}
    >
      <div className="infoGraphic__headline">
        {icon !== 'none' && <FuturiumIcon icon={icon} />}

        {number && (
          <Headline tag="p" className="infoGraphic__number">
            {number}
          </Headline>
        )}

        {subline && (
          <Headline tertiary tag="p" className="infoGraphic__subline">
            {subline}
          </Headline>
        )}
      </div>

      {copy && <MixedCopy fullWidth className="infoGraphic__copy" html={copy} />}
    </StyledInfoGraphic>
  );
};

InfoGraphic.propTypes = {
  alignment: PropTypes.oneOf(['left', 'right']),
  vertical: PropTypes.bool,
  icon: PropTypes.string,
  number: PropTypes.string,
  subline: PropTypes.string,
  copy: PropTypes.string
};

export default InfoGraphic;
